"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Org/Org.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _user = require('shared/selectors/user');


var _org = require('shared/selectors/org');
var _myRelations = require('shared/selectors/myRelations');
var _hooks = require('web/services/hooks');
var _useOrgAccount = require('shared/hooks/useOrgAccount');
var _useAccounts = require('web/screens/Settings/hooks/useAccounts');

var _PageLayout = require('web/components/Settings/PageLayout'); var _PageLayout2 = _interopRequireDefault(_PageLayout);
var _Org = require('web/components/Settings/Org');
var _InfoTab = require('./InfoTab'); var _InfoTab2 = _interopRequireDefault(_InfoTab);
var _MembersTab = require('./MembersTab'); var _MembersTab2 = _interopRequireDefault(_MembersTab);
var _MembershipTab = require('./MembershipTab'); var _MembershipTab2 = _interopRequireDefault(_MembershipTab);
var _SubscriptionsTab = require('./SubscriptionsTab'); var _SubscriptionsTab2 = _interopRequireDefault(_SubscriptionsTab);
var _ConsentTab = require('./ConsentTab'); var _ConsentTab2 = _interopRequireDefault(_ConsentTab);
var _BrandingTab = require('./BrandingTab'); var _BrandingTab2 = _interopRequireDefault(_BrandingTab);














const TAB_NAMES = ['info', 'members', 'plan', 'consent', 'membership', 'branding'] 

const OrgPage = ({
  gotoOrgInfo,
  gotoOrgMembers,
  gotoOrgMembership,
  gotoOrgSubscriptions,
  gotoAccountSettings,
  gotoOrgConsent,
  gotoOrgBranding,
  gotoOrgsList,
  orgKey,
  tabName,
}) => {
  const numberOfMembers = _hooks.useAppSelector.call(void 0, state =>
    _nullishCoalesce(_optionalChain([(orgKey && _org.selectOrgV1.call(void 0, state, orgKey)), 'optionalAccess', _ => _.NumberOfMembers]), () => ( 0)))
  const orgName = _hooks.useAppSelector.call(void 0, state =>
    _nullishCoalesce(_optionalChain([(orgKey && _org.selectOrgByKey.call(void 0, orgKey, state)), 'optionalAccess', _2 => _2.Name]), () => ( '')))
  // One GetAccount for this org: undefined while loading, null when the
  // account isn't flagged or failed to load (today's pages).
  const account = _useOrgAccount.useOrgAccount.call(void 0, orgKey)
  const isAccountManager = _useOrgAccount.isManagedAccount.call(void 0, account)
  // Owners and IT administer every org of their account (D-34), also where
  // their own membership is a User's, as the server treats them.
  const amIAdmin = _hooks.useAppSelector.call(void 0, state => !!orgKey && _user.selectAmIAdminInOrg.call(void 0, state, orgKey)) || isAccountManager
  const orgHasAdvancedSearch = _hooks.useAppSelector.call(void 0, state =>
    !!orgKey && _org.selectOrgHasAdvancedSearch.call(void 0, state, orgKey))
  const orgHasConsent = _hooks.useAppSelector.call(void 0, state =>
    !!orgKey && _org.selectOrgHasConsent.call(void 0, state, orgKey))
  const orgHasBranding = _hooks.useAppSelector.call(void 0, state =>
    !!orgKey && _org.selectOrgHasBranding.call(void 0, state, orgKey))
  const hasPendingUsers = _hooks.useAppSelector.call(void 0, state =>
    !!orgKey && _myRelations.selectPendingUsersInOrg.call(void 0, state, orgKey).length > 0)

  // In a flagged account the plan lives on Account → Plan (D-67); the tab
  // waits for the account so it never flashes there.
  const isFlagged = !!_optionalChain([account, 'optionalAccess', _3 => _3.Flagged])
  const hasPlanTab = amIAdmin && account !== undefined && !isFlagged
  const securityHome = _useAccounts.useSecuritySettingsHome.call(void 0, account)

  _react.useLayoutEffect.call(void 0, 
    () => {
      if (!orgKey || !tabName) return
      const isAdminTab = tabName === 'members' || tabName === 'plan' || tabName === 'consent' || tabName === 'branding'
      const isMovedPlan = tabName === 'plan' && isFlagged
      const isHiddenConsentTab = tabName === 'consent' && !orgHasConsent
      const isHiddenBrandingTab = tabName === 'branding' && !orgHasBranding
      // An Owner or IT person is an admin only once their account loads.
      const isNotAdmin = !amIAdmin && account !== undefined
      if (!TAB_NAMES.includes(tabName) || (isAdminTab && isNotAdmin) || isMovedPlan || isHiddenConsentTab || isHiddenBrandingTab) {
        gotoOrgInfo(orgKey)
      }
    },
    [tabName, amIAdmin, account, gotoOrgInfo, orgKey, isFlagged, orgHasConsent, orgHasBranding],
  )

  const tabs = _react.useMemo.call(void 0, 
    () => [
      { name: 'info', label: 'Details' },
      amIAdmin && { name: 'members', label: `Members (${numberOfMembers})` },
      !amIAdmin && { name: 'membership', label: 'Membership' },
      hasPlanTab && { name: 'plan', label: 'Plan' },
      amIAdmin && orgHasConsent && { name: 'consent', label: 'Consent' },
      amIAdmin && orgHasBranding && { name: 'branding', label: 'Patient chat branding' },
    ].filter(Boolean) ,
    [amIAdmin, numberOfMembers, hasPlanTab, orgHasConsent, orgHasBranding],
  )

  const onSelectTab = _react.useCallback.call(void 0, 
    (t) => {
      if (!orgKey) return
      const goto = {
        info: gotoOrgInfo,
        members: gotoOrgMembers,
        membership: gotoOrgMembership,
        plan: gotoOrgSubscriptions,
        consent: gotoOrgConsent,
        branding: gotoOrgBranding,
      }[t]
      goto(orgKey)
    },
    [orgKey, gotoOrgInfo, gotoOrgMembers, gotoOrgMembership, gotoOrgSubscriptions, gotoOrgConsent, gotoOrgBranding],
  )

  const accountSettingsOrgKey = isAccountManager ? account.DefaultOrgKey : null
  const onOpenAccountSettings = _react.useMemo.call(void 0, 
    () => accountSettingsOrgKey ? () => gotoAccountSettings(accountSettingsOrgKey) : null,
    [accountSettingsOrgKey, gotoAccountSettings],
  )

  if (!tabName || !orgKey) return null

  return (
    _react2.default.createElement(_PageLayout2.default, {
      title: orgName,
      bodyClassName: "settings--page--org",
      isBackBtnVisibleOnDesktop: true,
      onBack: gotoOrgsList, __self: this, __source: {fileName: _jsxFileName, lineNumber: 129}}

      , _react2.default.createElement(_Org.TabsHeader, { tabs: tabs, activeTab: tabName, onSelect: onSelectTab, __self: this, __source: {fileName: _jsxFileName, lineNumber: 135}} )
      ,  tabName === 'info' && (
        _react2.default.createElement(_InfoTab2.default, {
          orgKey: orgKey,
          isEditable: amIAdmin,
          securityHome: securityHome,
          onOpenAccountSettings: onOpenAccountSettings, __self: this, __source: {fileName: _jsxFileName, lineNumber: 137}}
        )
      )
      ,  tabName === 'members' && amIAdmin && (
        _react2.default.createElement(_MembersTab2.default, {
          orgKey: orgKey,
          orgName: orgName,
          hasPendingUsers: hasPendingUsers,
          canExportRelationships: orgHasAdvancedSearch,
          account: account, __self: this, __source: {fileName: _jsxFileName, lineNumber: 145}}
        )
      )
      ,  tabName === 'membership' && !amIAdmin && (
        _react2.default.createElement(_MembershipTab2.default, { orgKey: orgKey, gotoOrgInfo: gotoOrgInfo, __self: this, __source: {fileName: _jsxFileName, lineNumber: 154}} )
      )
      ,  tabName === 'plan' && hasPlanTab && (
        _react2.default.createElement(_SubscriptionsTab2.default, { orgKey: orgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 157}} )
      )
      ,  tabName === 'consent' && amIAdmin && orgHasConsent && (
        _react2.default.createElement(_ConsentTab2.default, { orgKey: orgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 160}} )
      )
      ,  tabName === 'branding' && amIAdmin && orgHasBranding && (
        _react2.default.createElement(_BrandingTab2.default, { orgKey: orgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 163}} )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, OrgPage)
